var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.getSize,"color":"#1f93d0"}},[(_vm.avatar)?_c('img',{attrs:{"src":_vm.avatar},on:{"error":_vm.imageLoadError}}):_c('v-icon',{attrs:{"size":_vm.getIconSize,"color":"white"}},[_vm._v(_vm._s(_vm.getIcon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }